export const PaperType = {
  Blank: 1,
  PaymentSlip_Bottom: 2,
  PZU: 4,
  Blank_PZU: 5,
  Blank_PaymentSlipBottom: 3,
  Blank_PaymentSLipBottom_PZU: 7
}
